// extracted by mini-css-extract-plugin
export var dropdown = "_tq-0";
export var imageWrapper = "_tq-3";
export var itemNameContainer = "_tq-1";
export var productImage = "_tq-2";
export var spinnerWrapper = "_tq-4";